import React, { Component } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Paper, Grid, Container, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AnnotationSectionsConfig from '../AnnotationSectionsConfig';
import './index.css';

export default class RelevantCriteriaCategories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: true,
    };
  }

  handleClick = () => {
    this.setState({
      active: !this.state.active,
    });
  };

  //return a list of jsx with category name and descriptions for each sourceType
  renderCriteriaDescription = () => {
    var array = [];
    AnnotationSectionsConfig[this.props.sourceType].categories.map(category => {
      array.push(
        <div key={category.description} className="category">
          <span className="categoryName">{category.name + ': '}</span>{' '}
          {category.description}
        </div>
      );
    });
    return array;
  };

  render() {
    return (
      <Paper className="card" elevation={0}>
        <Accordion elevation={0} defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="relevantCriteriaCategories-content"
            id="relevantCriteriaCategories-header"
          >
            <Typography> 
              Relevant Criteria Categories
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div>{this.renderCriteriaDescription()}</div>
            <div className="hyperlink">
              For more information:{' '}
              <a
                href="https://www.acmg.net/docs/Standards_Guidelines_for_the_Interpretation_of_Sequence_Variants.pdf"
                target="_blank"
              >
                Click Here
              </a>
            </div>
          </AccordionDetails>
        </Accordion>
      </Paper>
    );
  }
}
